module.exports = __webpack_public_path__ + "media/ss_photos/ss-overview-photo-00-dbce2099.webp";